"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
exports.default = (0, mobx_react_1.observer)(function (_a) {
    var tokenViewStore = _a.tokenViewStore, children = _a.children;
    var renderSearchInput = function () {
        return (react_1.default.createElement(kaleidoscope_1.SearchInput, { placeholder: "Type to filter tokens", label: "Filter Tokens", onClear: tokenViewStore.onSearchClear, onChange: tokenViewStore.onSearchChange, value: tokenViewStore.searchTerm }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "tokens-panel__header" },
            react_1.default.createElement("h2", { className: "tokens-panel__title" }, "Tokens"),
            renderSearchInput()),
        children));
});
